import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, ContentLoader } from '@dev/ee-components';
import { Link } from '@material-ui/core';
import styled from 'styled-components';
import { isEmpty, map } from 'lodash-es';
import { getApiPath } from '@api/services/Security';

import { getEmailsStore } from '@api/store/emails/actions';
import { getConfigStore } from '@api/store/config/actions';

type HeaderTitleWrapperProps = {
    align?: string;
    padding?: string;
};

const HeaderLine = styled.div`
    padding: 22px 0;
    display: flex;
    justify-content: flex-start;
`;

const HeaderTitleWrapper = styled.span<HeaderTitleWrapperProps>`
    width: 170px;
    height: 20px;
    display: inline-flex;
    align-items: ${(props) => (props.align ? props.align : 'center')};
    ${(props) => (props.padding ? `padding: ${props.padding};` : '')}
`;

const AttachmentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    div {
        padding-bottom: 8px;
    }
    div:last-of-type {
        padding-bottom: 0;
    }
`;

const Attachments = (): JSX.Element => {
    const { t } = useTranslation();
    const { email, emailLoading } = useSelector(getEmailsStore);
    const config = useSelector(getConfigStore);
    const apiPath = getApiPath(config);

    if (isEmpty(email?.Attachments)) {
        return null;
    }

    return (
        <HeaderLine>
            <HeaderTitleWrapper>
                <Typography variant="body2">{t('attachments')}</Typography>
            </HeaderTitleWrapper>
            {emailLoading ? (
                <ContentLoader mode="row" height={20} width={170} />
            ) : (
                <AttachmentWrapper>
                    {map(email?.Attachments, (attachment) => {
                        return (
                            <Typography variant="caption">
                                <Link
                                    href={`${apiPath}/view?notracking=true&msgid=${email?.Status?.MessageID}&attachment=${attachment.FileName}`}
                                >
                                    {attachment.FileName}
                                </Link>
                            </Typography>
                        );
                    })}
                </AttachmentWrapper>
            )}
        </HeaderLine>
    );
};

export default Attachments;
